module.exports = __webpack_public_path__ + "img/a_crustaceos.f9a6531c.svg";